// GERADO POR ambientes/gerar-config-web.js — NÃO EDITE À MÃO.
// Qualquer alteração aqui é sobrescrita no próximo build, e pior:
// desalinha o que o código usa do que o registro declara.
//
// ambiente: prod (Produção)
// gerado em: 2026-10-29T23:16:49.706Z
// commit:   6b3ac3c977a8df70d0aad3a9ec4e8fc84f6b42e0

export const AMBIENTE = "prod";
export const ROTULO_AMBIENTE = "Produção";
export const EH_PRODUCAO = true;
export const COMMIT = "6b3ac3c977a8df70d0aad3a9ec4e8fc84f6b42e0";

export const firebaseConfig = {
  apiKey: "AIzaSyCMiAaFHeU3_oa2KKiUXgMmRT7FacFZORk",
  authDomain: "revelar-frequencia-3194e.firebaseapp.com",
  projectId: "revelar-frequencia-3194e",
  storageBucket: "revelar-frequencia-3194e.firebasestorage.app",
  messagingSenderId: "290124927854",
  appId: "1:290124927854:web:74a0a1f2d64027fc3277f",
};
